import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import PolypaneIntro from "../../../../src/components/PolypaneIntro";
import ThanksCallout from "../../../../src/components/ThanksCallout";
import panecolor from "../../../../assets/images/docs/sync/panecolor.png";
import importantstyling from "../../../../assets/images/blogs/pp28/important.png";
import addproject from "../../../../assets/images/docs/projects/addproject.png";
import environments from "../../../../assets/images/docs/projects/environments.png";
import sortprojects from "../../../../assets/videos/blogs/pp28/sortprojects.mp4";
import sortbookmarks from "../../../../assets/videos/blogs/pp28/sortbookmarks.mp4";
import editselector from "../../../../assets/videos/blogs/pp28/editselector.mp4";
import browsebookmarks from "../../../../assets/images/docs/browse/bookmarks.png";
import consolegroup from "../../../../assets/images/blogs/pp28/consolegroup.png";
import newinstaller from "../../../../assets/images/blogs/pp28/installer.png";
import livereload from "../../../../assets/images/docs/livereload/livereload.png";
import browsefindinpage from "../../../../assets/images/docs/browse/findinpage.png";
import autocompletes from "../../../../assets/images/blogs/pp28/autocompletes.png";
import snippetscommand from "../../../../assets/images/blogs/pp28/snippetscommand.png";
import polycli from "../../../../assets/images/blogs/pp28/polycli.png";
import bskytxt from "../../../../assets/images/blogs/pp28/bskytxt.png";
import yellowlocalhost from "../../../../assets/images/blogs/pp28/yellowlocalhost.png";
import boxmodel28 from "../../../../assets/images/blogs/pp28/boxmodel28.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  PolypaneIntro,
  ThanksCallout,
  panecolor,
  importantstyling,
  addproject,
  environments,
  sortprojects,
  sortbookmarks,
  editselector,
  browsebookmarks,
  consolegroup,
  newinstaller,
  livereload,
  browsefindinpage,
  autocompletes,
  snippetscommand,
  polycli,
  bskytxt,
  yellowlocalhost,
  boxmodel28,
  React
};